import React from "react";
import "./LegalDocument.css";

const renderListItem = (item) => {
  if (typeof item === "string") {
    return item;
  }

  return (
    <>
      {item.label ? <strong>{item.label}</strong> : null}
      {item.label ? " " : null}
      {item.text}
    </>
  );
};

const LegalDocument = ({
  documentData,
  compact = false,
  showTitle = true,
  className = "",
}) => {
  return (
    <div
      className={`legal-document${compact ? " legal-document--compact" : ""}${
        className ? ` ${className}` : ""
      }`}
    >
      {showTitle ? (
        <h1 className="legal-document-title">{documentData.title}</h1>
      ) : null}

      <div className="legal-document-content">
        {documentData.rows.map((row, rowIndex) => (
          <div key={`${documentData.title}-row-${rowIndex}`} className="legal-document-row">
            {row.map((column, columnIndex) => (
              <div
                key={`${documentData.title}-column-${rowIndex}-${columnIndex}`}
                className={`legal-document-column${
                  column.fullWidth ? " legal-document-column-full" : ""
                }`}
              >
                <div className="legal-document-text">
                  {column.sections.map((section, sectionIndex) => (
                    <div
                      key={`${section.heading}-${sectionIndex}`}
                      className="legal-document-section"
                    >
                      <h3 className="legal-document-heading">{section.heading}</h3>
                      {section.blocks.map((block, blockIndex) => {
                        if (block.type === "paragraph") {
                          return (
                            <p
                              key={`${section.heading}-paragraph-${blockIndex}`}
                              className={`legal-document-paragraph${
                                block.tone === "secondary"
                                  ? " legal-document-paragraph-secondary"
                                  : ""
                              }${
                                block.className ? ` ${block.className}` : ""
                              }`}
                            >
                              {block.lines
                                ? block.lines.map((line, lineIndex) => (
                                    <React.Fragment key={`${line}-${lineIndex}`}>
                                      {line}
                                      {lineIndex < block.lines.length - 1 ? <br /> : null}
                                    </React.Fragment>
                                  ))
                                : block.text}
                            </p>
                          );
                        }

                        if (block.type === "list") {
                          return (
                            <ul
                              key={`${section.heading}-list-${blockIndex}`}
                              className={`legal-document-list${
                                block.spaced ? " legal-document-list-spaced" : ""
                              }`}
                            >
                              {block.items.map((item, itemIndex) => (
                                <li
                                  key={`${section.heading}-item-${itemIndex}`}
                                  className={
                                    typeof item === "object" && item.note
                                      ? "legal-document-note"
                                      : ""
                                  }
                                >
                                  {renderListItem(item)}
                                </li>
                              ))}
                            </ul>
                          );
                        }

                        return null;
                      })}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LegalDocument;
